import React from "react";
import AppRoutes from "./routes/AppRoutes";
import {BrowserRouter} from "react-router-dom";
import {Auth0ProviderWithRedirectCallback} from "./routes/Auth0ProviderWithRedirectCallback";
import { useConfigContext } from "./contexts/ConfigContext/ConfigContextProvider";

const App = () => {

    return (
        <div>
            <BrowserRouter>
                <Auth0ProviderWithRedirectCallback
                    domain={process.env.REACT_APP_AUTH0_DOMAIN}
                    clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
                    authorizationParams={{
                        redirect_uri: `${window.location.origin}/callback`,
                    }}
                >
                    <AppRoutes/>
                </Auth0ProviderWithRedirectCallback>
            </BrowserRouter>
        </div>
    );
};

export default App;
